import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { CartProvider } from "./context/CartContext";
import { AdminAuthProvider } from "./context/AdminAuthContext";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";

// Customer Pages
import HomePage from "./pages/HomePage";
import ShopPage from "./pages/ShopPage";
import ProductPage from "./pages/ProductPage";
import CartPage from "./pages/CartPage";
import CheckoutPage from "./pages/CheckoutPage";
import CheckoutSuccessPage from "./pages/CheckoutSuccessPage";
import OrderTrackingPage from "./pages/OrderTrackingPage";
import CookingVideosPage from "./pages/CookingVideosPage";
import AboutPage from "./pages/AboutPage";
import FAQPage from "./pages/FAQPage";
import ContactPage from "./pages/ContactPage";
import PrivacyPage from "./pages/PrivacyPage";
import TermsPage from "./pages/TermsPage";
import RefundsPage from "./pages/RefundsPage";
import ShippingPage from "./pages/ShippingPage";

// Admin Pages
import AdminLoginPage from "./pages/admin/AdminLoginPage";
import AdminLayout from "./pages/admin/AdminLayout";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminOrdersPage from "./pages/admin/AdminOrdersPage";
import AdminOrderDetailPage from "./pages/admin/AdminOrderDetailPage";
import AdminInventoryPage from "./pages/admin/AdminInventoryPage";
import AdminVideosPage from "./pages/admin/AdminVideosPage";
import AdminAnalyticsPage from "./pages/admin/AdminAnalyticsPage";
import AdminDiscountsPage from "./pages/admin/AdminDiscountsPage";
import AdminDevicesPage from "./pages/admin/AdminDevicesPage";
import PackingSlipPage from "./pages/admin/PackingSlipPage";
import ProtectedAdminRoute from "./pages/admin/ProtectedAdminRoute";

// Customer Layout Wrapper
const CustomerLayout = ({ children }) => (
  <>
    <Header />
    <main className="flex-1">{children}</main>
    <Footer />
  </>
);

function App() {
  return (
    <AdminAuthProvider>
      <CartProvider>
        <div className="App min-h-screen flex flex-col">
          <BrowserRouter>
            <Routes>
              {/* Admin Routes - No Header/Footer */}
              <Route path="/admin/login" element={<AdminLoginPage />} />
              <Route
                path="/admin/orders/:orderId/packing-slip"
                element={
                  <ProtectedAdminRoute>
                    <PackingSlipPage />
                  </ProtectedAdminRoute>
                }
              />
              <Route
                path="/admin"
                element={
                  <ProtectedAdminRoute>
                    <AdminLayout />
                  </ProtectedAdminRoute>
                }
              >
                <Route index element={<AdminDashboard />} />
                <Route path="orders" element={<AdminOrdersPage />} />
                <Route path="orders/:orderId" element={<AdminOrderDetailPage />} />
                <Route path="inventory" element={<AdminInventoryPage />} />
                <Route path="videos" element={<AdminVideosPage />} />
                <Route path="analytics" element={<AdminAnalyticsPage />} />
                <Route path="discounts" element={<AdminDiscountsPage />} />
                <Route path="devices" element={<AdminDevicesPage />} />
              </Route>

              {/* Customer Routes - With Header/Footer */}
              <Route path="/" element={<CustomerLayout><HomePage /></CustomerLayout>} />
              <Route path="/shop" element={<CustomerLayout><ShopPage /></CustomerLayout>} />
              <Route path="/shop/:productId" element={<CustomerLayout><ProductPage /></CustomerLayout>} />
              <Route path="/product/:productId" element={<CustomerLayout><ProductPage /></CustomerLayout>} />
              <Route path="/cart" element={<CustomerLayout><CartPage /></CustomerLayout>} />
              <Route path="/checkout" element={<CustomerLayout><CheckoutPage /></CustomerLayout>} />
              <Route path="/checkout/success" element={<CustomerLayout><CheckoutSuccessPage /></CustomerLayout>} />
              <Route path="/cooking-videos" element={<CustomerLayout><CookingVideosPage /></CustomerLayout>} />
              <Route path="/track" element={<OrderTrackingPage />} />
              <Route path="/order-tracking" element={<OrderTrackingPage />} />
              <Route path="/about" element={<CustomerLayout><AboutPage /></CustomerLayout>} />
              <Route path="/faq" element={<CustomerLayout><FAQPage /></CustomerLayout>} />
              <Route path="/contact" element={<CustomerLayout><ContactPage /></CustomerLayout>} />
              <Route path="/privacy" element={<CustomerLayout><PrivacyPage /></CustomerLayout>} />
              <Route path="/terms" element={<CustomerLayout><TermsPage /></CustomerLayout>} />
              <Route path="/refunds" element={<CustomerLayout><RefundsPage /></CustomerLayout>} />
              <Route path="/shipping" element={<CustomerLayout><ShippingPage /></CustomerLayout>} />
            </Routes>
          </BrowserRouter>
          <Toaster 
            position="top-right" 
            richColors 
            toastOptions={{
              style: {
                fontFamily: "'Work Sans', sans-serif",
              },
            }}
          />
        </div>
      </CartProvider>
    </AdminAuthProvider>
  );
}

export default App;
